$(document).ready(function() {
  $('.featured_collection_slider .collection .grid').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.8,
          slidesToScroll: 1,
          arrows: false,
        }
      },
      {
        breakpoint: 424,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
          arrows: false,
        }
      }
    ]
  });

  $(window).on('scroll', function () {
    var $Announcement_Height = $('#conversions_layers_root').height(),
        $Tabbing_List = $('.sticky_navigation');
    $($Tabbing_List).css('top', $Announcement_Height - 1);

    var $totalTop = $Announcement_Height + $Tabbing_List.height() + 15;
    $('.personalized_heading_wrapper').css('top', $totalTop);
  });

  $(document).on('click','.sticky_navigation__item a', function() {
    var $Announcement_Height1 = $('#conversions_layers_root').height(),
    $Tabbing_List1 = $('.sticky_navigation').height();

    if($Announcement_Height1) {
       var $totleHeight = $Announcement_Height1 + $Tabbing_List1 - 30;
    
      var idVal = $(this).attr('href');
      var offsetVal = $(idVal).offset().top - $totleHeight;
      $('html, body').animate({
          scrollTop: offsetVal
      }, 1000);
    }
    else {
       var $totleHeight = $Tabbing_List1 - 30;
    
      var idVal = $(this).attr('href');
      var offsetVal = $(idVal).offset().top - $totleHeight;
      $('html, body').animate({
          scrollTop: offsetVal
      }, 1000);
    }

   
  });
})